/* import __COLOCATED_TEMPLATE__ from './group-activity-filter.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./group-activity-filter.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: "li"
}));